<template>
  <div>
    <!-- Если фильтров больше одного, выводим над таблицей, если меньше, выводим в шапке таблицы -->
    <!-- Или если столбец с controls не выводится, выводим поиск над таблицей -->
    <div
      v-if="
        (serializeDataSearchFields && serializeDataSearchFields.length > 1) ||
        (serializeDataSearchFields && !options.controls)
      "
      class="filter-head"
    >
      <TableSearch
        v-for="(search, index) in serializeDataSearchFields"
        :key="index"
        :options="search"
        @quickFilter="onQuickFilter"
        @searchSingle="onSearchSingle"
      />
    </div>
    <el-table
      ref="table"
      v-loading="loading"
      :data="data"
      :default-sort="defaultSort"
      :class="cssClass"
      border
      stripe
      row-key="id"
      @sort-change="onSort"
      @filter-change="onFilter"
      @selection-change="onSelection"
      @select-all="onSelectionAll"
    >
      <el-table-column
        v-if="methodDeleteRows"
        type="selection"
        width="45"
        align="center"
      />
      <template v-for="(column, index) in columns">
        <template v-if="column.children">
          <el-table-column
            v-for="columnChild in column.children"
            :key="columnChild.prop"
            :label="columnChild.label"
            :prop="columnChild.prop"
            :width="columnWidth(columnChild.width, columnChild)"
          >
            <template slot-scope="scope">
              <TableColumn
                :column="columnChild"
                :row="scope.row[column.prop]"
                :options="options"
              />
            </template>
          </el-table-column>
        </template>
        <el-table-column
          v-else
          :key="index"
          :label="column.label"
          :prop="column.prop"
          :width="columnWidth(column.width, column)"
          :filter-multiple="false"
          :filters="column.filter && column.filter.values"
          :filtered-value="defaultFilter(column.filter)"
          :column-key="column.filter && column.filter.name"
          :sortable="options.sortable && column.sortable !== false"
        >
          <template slot-scope="scope">
            <slot
              v-if="column.type === 'button-edit'"
              :data="data"
              :row="scope.row"
              :index="scope.$index"
              name="controls"
            >
              <router-link
                v-if="options.editable"
                :to="`edit/${
                  scope.row[options.id] || scope.row[uniqKey] || ''
                }${column.postfix ? '/' + column.postfix : ''}`"
              >
                <el-button icon="el-icon-edit" size="mini"
                  >Редактировать</el-button
                >
              </router-link>
            </slot>
            <TableColumn
              v-else
              :column="column"
              :row="scope.row"
              :options="options"
              :data="data"
            />
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="options.controls"
        align="center"
        :width="options.controls.width || 200"
      >
        <template
          v-if="
            serializeDataSearchFields && serializeDataSearchFields.length < 2
          "
          slot="header"
          slot-scope="scope"
        >
          <div class="filter-column">
            <TableSearch
              v-for="(search, index) in serializeDataSearchFields"
              :key="index"
              :options="search"
              :fix-lint="scope"
              size="mini"
              @quickFilter="onQuickFilter"
              @searchSingle="onSearchSingle"
            />
          </div>
        </template>
        <template slot-scope="scope">
          <div class="flex">
            <el-tooltip
              v-if="options.delete_row && scope.row.status !== 'deleted'"
              :content="options.delete_row.buttonName"
              placement="top"
            >
              <el-button
                type="danger"
                icon="el-icon-close"
                plain
                size="mini"
                @click="onDeleteId(scope.row[options.id])"
              />
            </el-tooltip>
            <slot
              v-if="options.edit"
              :data="data"
              :row="scope.row"
              :index="scope.$index"
              name="controls"
            >
              <router-link
                v-if="options.editable"
                :to="`edit/${
                  scope.row[options.id] || scope.row[uniqKey] || ''
                }${editById ? '/' + byId : ''}`"
              >
                <el-button icon="el-icon-edit" size="mini"
                  >Редактировать</el-button
                >
              </router-link>
            </slot>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <slot name="footer">
        <el-popconfirm
          v-if="methodDeleteRows"
          v-show="selected.length"
          title="Вы уверены, что хотите удалить?"
          confirm-button-text="Да"
          cancel-button-text="Нет, Спасибо"
          icon="el-icon-info"
          icon-color="red"
          @confirm="onDelete"
        >
          <el-button
            slot="reference"
            type="danger"
            icon="el-icon-delete"
            size="mini"
            >Удалить</el-button
          >
        </el-popconfirm>
      </slot>
    </div>
    <pagination v-show="total > 0" :total="total" :size="options.size" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import TableColumn from "@/components/TableColumn";
import TableSearch from "@/components/TableSearch";
import { updateQuery } from "@/utils";
import Sortable from "sortablejs";

export default {
  name: "Table",
  components: {
    Pagination,
    TableColumn,
    TableSearch,
  },
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    methodFetchData: {
      type: Function,
    },
    methodFetchDataId: {
      type: Function,
    },
    methodDeleteRows: {
      type: Function,
      default: null,
    },
    methodDeleteRow: {
      type: Function,
      default: null,
    },
    methodRowDrop: {
      type: Function,
      default: null,
    },
    methodFetchSingle: {
      type: Function,
      default: null,
    },
    methodPollingData: {
      type: Function,
      default: null,
    },
    byId: {
      type: [String, Number, Object],
      default: null,
    },
    editById: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      data: [],
      total: 0,
      selected: [],
    };
  },
  computed: {
    defaultSort() {
      const {
        query: { sort },
      } = this.$route;

      if (sort) {
        if (sort[0] === "-") {
          return {
            prop: sort.slice(1),
            order: "descending",
          };
        }

        return {
          prop: sort,
          order: "ascending",
        };
      }
      return {};
    },
    cssClass() {
      return {
        "rows-drag-drop": typeof this.methodRowDrop === "function",
      };
    },
    uniqKey() {
      if (this.options.id) {
        return this.options.id;
      }
      return this.columns[0].prop; // ключевое поле, всегда первое в списке колонок!
    },
    serializeDataSearchFields() {
      if (this.options.search && typeof this.options.search === "object") {
        return [this.options.search];
      }

      return this.options.search_list;
    },
  },
  watch: {
    $route(to) {
      if (!this.loading) {
        this.fetchData(to.query);
      }
    },
    byId() {
      this.fetchDataById();
    },
  },
  created() {
    if (this.options.editable === undefined) {
      this.options.editable = true;
    }
    this.loading = true;
    this.fetchData();
    if (this.methodPollingData) {
      this.polling = setInterval(this.pollingData, 3000);
    }
  },
  mounted() {
    if (typeof this.methodRowDrop === "function") {
      this.initRowDragAndDrop();
    }
    if (this.byId) {
      this.fetchDataById();
      // this.$root.$on("uploaded", () => this.fetchDataById());
    } else {
      this.$root.$on("uploaded", () => this.fetchData());
    }
  },
  methods: {
    async fetchDataById() {
      try {
        const data = await this.methodFetchDataId(this.byId);
        if (Array.isArray(data)) {
          this.data = data;
          this.total = Infinity;
        } else {
          const { total = 0, items = [] } = data;
          this.total = total;
          this.data = items;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchData() {
      const { sort } = this.$route.query;
      //  дефолтная сортировка по id
      if (
        !sort &&
        this.columns.findIndex((e) => e.prop === "id" && !e.notDefaultSort) !==
          -1
      )
        updateQuery(this, { sort: "-id" });
      //  дефолтная сортировка дате создания
      if (
        !sort &&
        this.columns.findIndex(
          (e) => e.prop === "created_at" && !e.notDefaultSort
        ) !== -1
      )
        updateQuery(this, { sort: "-created_at" });
      if (
        !sort &&
        this.columns.findIndex(
          (e) => e.prop === "created" && !e.notDefaultSort
        ) !== -1
      )
        updateQuery(this, { sort: "-created" });
      //  дефолтная сортировка для идентификаторов сегментации
      if (
        !sort &&
        this.columns.findIndex(
          (e) => e.prop === "identifier" && !e.notDefaultSort
        ) !== -1
      )
        updateQuery(this, { sort: "-identifier" });

      this.loading = true;
      try {
        const data = await this.methodFetchData(
          this.$route.query,
          this.$route.params
        );
        if (Array.isArray(data)) {
          this.data = data;
          this.total = Infinity;
        } else {
          // const { total = 0, items = [] } = data;
          const { items = [data] } = data;
          this.total = items.length;
          this.data = items;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async pollingData() {
      const token = this.$store.getters.pollingToken;
      if (token === null) {
        clearInterval(this.polling);
        return;
      }
      try {
        const data = await this.methodPollingData(token);
        const limit = this.$route.query.limit;
        if (data.id === token) {
          this.total++;
          if (limit && this.data.length() === limit) {
            this.data.pop();
          }
          this.data.unshift(data);
          this.$store.dispatch("polling/setPollingToken", null);
          clearInterval(this.polling);
        }
      } catch (e) {
        clearInterval(this.polling);
      }
    },
    getList() {
      return this.data;
    },
    defaultFilter(filter) {
      if (!filter) return;

      const { name } = filter;
      const { query } = this.$route;

      if (name) {
        return [query[name]];
      }
    },
    onFilter(filters) {
      const queries = {};

      for (const filter in filters) {
        const value = filters[filter];

        queries[filter] = value[0];
      }
      updateQuery(this, queries);
    },
    onSort(column) {
      const { prop, order } = column;

      if (order) {
        updateQuery(this, {
          sort: `${order === "descending" ? "-" : ""}${prop}`,
        });
      } else {
        updateQuery(this, { sort: null });
      }
    },
    selectOnlyOneRow(val) {
      val.forEach((row, index) => {
        if (index !== 0) {
          this.$refs.table.toggleRowSelection(val[0]);
        }
      });
      const selected = val[val.length - 1];
      this.selected = selected ? [selected] : [];
    },
    onSelection(val) {
      if (this.options.disabledDeleteMultipleRows) {
        this.selectOnlyOneRow(val);
      } else {
        this.selected = val;
      }
    },
    onSelectionAll() {
      if (this.options.disabledDeleteMultipleRows) {
        this.$refs.table.clearSelection();
        this.selected = [];
      }
    },
    /**
     * Преобразуем список строк в список идентификаторов(uniqKey)
     * @param {Array} array список строк
     * @returns список идентификаторов
     */
    normalizeArrayOfUniqKey(array) {
      return array.map((e) => {
        if (typeof e === "object") {
          e = e[this.uniqKey];
        }
        return e;
      });
    },
    /**
     * Приводим ответы сервера к единому виду
     * @param {Array, Object, undefined} response ответ сервера
     * на сервере не соблюдается единый формат ответа,
     * некоторые методы отвечают массивом айдишников,
     * некоторые массивом объектов,
     * при удалении по одной строке, возвращается объект строки
     * так же возможен ответ только статусом, без данных
     * @returns массив удаленных строк
     */
    normalizeResponseDeleteRows(response) {
      let result = [];

      if (Array.isArray(response)) {
        result = response;
      } else if (typeof response === "object") {
        result.push(response);
      }

      return result;
    },
    async onDelete() {
      const { params } = this.$route;

      try {
        const selectedRows = this.normalizeArrayOfUniqKey(this.selected);
        const resp = await this.methodDeleteRows(selectedRows, params);
        const data = this.normalizeResponseDeleteRows(resp);
        // если не удалось получить список строк с сервера, удаляем выбранные строки
        const deletedRows = data.length
          ? this.normalizeArrayOfUniqKey(data)
          : selectedRows;

        this.data = this.data.filter(
          (row) => !deletedRows.includes(row[this.uniqKey])
        );
        this.total = this.total - deletedRows.length;

        this.$message({
          type: "success",
          message: "Выбранные записи удалены",
        });
      } catch (err) {
        console.log(err);
      }
    },
    async onDeleteId(id) {
      this.loading = true;
      try {
        await this.methodDeleteRow(id, { id: id });

        this.data = this.data.filter((row) => row.id !== id);
        this.total = this.total - 1;

        this.$message({
          type: "success",
          message: "Запись удалена",
        });
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    columnWidth(width, column) {
      if (width) return width;
      if (column.prop === "id") return 70;
      if (column.type === "bool" || column.type === "boolean") return 120;
      if (column.type === "preview") return 170;
      if (column.type === "date") return 180;
    },
    initRowDragAndDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        draggable: ".el-table__row",
        onEnd(event) {
          _this.data = _this.methodRowDrop({ event, rows: _this.data });
        },
      });
    },
    onQuickFilter(ev) {
      if (
        (ev.value.length === 1 && ev.key !== "Backspace") ||
        ev.key === "MetaLeft"
      ) {
        this.dataFull = this.data;
      }
      if (ev.key === "Backspace") {
        this.data = this.dataFull;
      }
      if (this.data)
        this.data = this.data.filter((item) =>
          item[ev.name].toString(10).includes(ev.value)
        );
    },
    onSearchSingle(id) {
      const _this = this;
      _this.methodFetchSingle(id).then((data) => {
        _this.data = [data];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.footer {
  margin-top: 20px;
  margin-bottom: -10px;
}

.filter {
  &-head {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, auto));
    gap: 15px;
    margin-bottom: 20px;
    align-items: center;
  }

  &-column {
    display: grid;
    gap: 10px;
  }
}
</style>

<style lang="scss">
.rows-drag-drop {
  tr td {
    cursor: move;
  }
}
.control-btn {
  width: 155px;
  margin-top: 10px;
}
</style>
